import { memo } from 'react';
import {
  lineHeightStyle,
  styledComponent,
  isExistAnyMentalStateExaminationData,
  defaultMentalStateData,
} from '../../../../utils/helpers';
import ChiefComplainDeleteBtn from '../chiefComplainDeleteBtn';

const MentalStateExaminationView = ({
  prescriptionItems,
  selectedOnExamination,
  setSelectedOnExamination,
  isHistoryPage,
}) => {
  let { mentalStateExamination } = selectedOnExamination;
  mentalStateExamination = mentalStateExamination || {};

  const removeItemsData = (fieldName) => {
    const resetFields = defaultMentalStateData();

    // Handle field reset
    if (fieldName in resetFields) {
      mentalStateExamination[fieldName] = resetFields[fieldName];
    }

    setSelectedOnExamination({
      ...selectedOnExamination,
      mentalStateExamination: { ...mentalStateExamination },
    });
  };

  const Title = styledComponent(
    prescriptionItems?.items?.['on-examination']?.itemStyle || {},
  );
  const Value = styledComponent(
    prescriptionItems?.items?.['on-examination']?.subItemStyle || {},
  );

  const flexRow = { display: 'flex', justifyContent: 'space-between', alignItems: 'center' };

  return (
    <>
      {isExistAnyMentalStateExaminationData(mentalStateExamination) && (
        <>
          <div className="mentalState-sub-title">Mental State Examination</div>
          <ul style={lineHeightStyle('on-examination', prescriptionItems)}>
            {mentalStateExamination.appearanceAndBehavior && (
              <li className="text-left" style={flexRow}>
                <span>
                  <Title>Appearance and Behavior:</Title>{' '}
                  <Value>{mentalStateExamination.appearanceAndBehavior}</Value>
                </span>
                {!isHistoryPage && (
                  <ChiefComplainDeleteBtn
                    action={removeItemsData}
                    itemName="appearanceAndBehavior"
                  />
                )}
              </li>
            )}

            {mentalStateExamination.speech && (
              <li className="text-left" style={flexRow}>
                <span>
                  <Title>Speech:</Title>{' '}
                  <Value>{mentalStateExamination.speech}</Value>
                </span>
                {!isHistoryPage && (
                  <ChiefComplainDeleteBtn
                    action={removeItemsData}
                    itemName="speech"
                  />
                )}
              </li>
            )}

            {mentalStateExamination.moodAndAffect && (
              <li className="text-left" style={flexRow}>
                <span>
                  <Title>Mood and Affect:</Title>{' '}
                  <Value>{mentalStateExamination.moodAndAffect}</Value>
                </span>
                {!isHistoryPage && (
                  <ChiefComplainDeleteBtn
                    action={removeItemsData}
                    itemName="moodAndAffect"
                  />
                )}
              </li>
            )}

            {mentalStateExamination.perception && (
              <li className="text-left" style={flexRow}>
                <span>
                  <Title>Perception:</Title>{' '}
                  <Value>{mentalStateExamination.perception}</Value>
                </span>
                {!isHistoryPage && (
                  <ChiefComplainDeleteBtn
                    action={removeItemsData}
                    itemName="perception"
                  />
                )}
              </li>
            )}

            {mentalStateExamination.thoughtProcess && (
              <li className="text-left" style={flexRow}>
                <span>
                  <Title>Thought Process:</Title>{' '}
                  <Value>{mentalStateExamination.thoughtProcess}</Value>
                </span>
                {!isHistoryPage && (
                  <ChiefComplainDeleteBtn
                    action={removeItemsData}
                    itemName="thoughtProcess"
                  />
                )}
              </li>
            )}

            {mentalStateExamination.thoughtContent && (
              <li className="text-left" style={flexRow}>
                <span>
                  <Title>Thought Content:</Title>{' '}
                  <Value>{mentalStateExamination.thoughtContent}</Value>
                </span>
                {!isHistoryPage && (
                  <ChiefComplainDeleteBtn
                    action={removeItemsData}
                    itemName="thoughtContent"
                  />
                )}
              </li>
            )}

            {mentalStateExamination.insight && (
              <li className="text-left" style={flexRow}>
                <span>
                  <Title>Insight:</Title>{' '}
                  <Value>{mentalStateExamination.insight}</Value>
                </span>
                {!isHistoryPage && (
                  <ChiefComplainDeleteBtn
                    action={removeItemsData}
                    itemName="insight"
                  />
                )}
              </li>
            )}

            {mentalStateExamination.judgment && (
              <li className="text-left" style={flexRow}>
                <span>
                  <Title>Judgment:</Title>{' '}
                  <Value>{mentalStateExamination.judgment}</Value>
                </span>
                {!isHistoryPage && (
                  <ChiefComplainDeleteBtn
                    action={removeItemsData}
                    itemName="judgment"
                  />
                )}
              </li>
            )}

            {mentalStateExamination.cognition && (
              <li className="text-left" style={flexRow}>
                <span>
                  <Title>Cognition:</Title>{' '}
                  <Value>{mentalStateExamination.cognition}</Value>
                </span>
                {!isHistoryPage && (
                  <ChiefComplainDeleteBtn
                    action={removeItemsData}
                    itemName="cognition"
                  />
                )}
              </li>
            )}
          </ul>
        </>
      )}
    </>
  );
};

export default memo(MentalStateExaminationView);
